import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { gateway } from "../gateway";
import { updateSignupEmployeeState } from "../redux/features/signupEmployeeStateSlice";
import { CheckEmployeeRequirements } from "./checkEmployeeRequirements";
import { SignUpNextButton } from "./signupNextButton";

export const ConnectEmployeeRequirements = ({
  checkedState,
  nextViewComponentState,
  previousViewEntityState,
  updateComponentState = updateSignupEmployeeState,
}) => {
  const currPage = "/signupEmployee";
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [requirements, setRequirements] = useState([]);

  const getWorkRequirements = async (type) => {
    try {
      const response = await gateway.get(`/workrequirements`);
      const data = response.data.data.items;
      setRequirements(data);
      console.log("the data: ", data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getWorkRequirements(requirements); // Cambiamos la variable residencialType por la cadena "residencial"
  }, []);

  return (
    <div
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "auto",
      }}
    >
      <Box
        style={{
          borderRadius: "10px",
          backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
          display: "flex",
          flexDirection: "column",
          padding: "20px",
          alignItems: "center",
          transition: "opacity 1s ease-in-out",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          height: "auto",
        }}
        sx={{
          marginTop: { xs: 2, md: 1 },
          width: { xs: "100%", md: 600 },
          marginLeft: { md: -15 },
        }}
      >
        <Grid container>
          <Grid item xs={12} md={12}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                marginBottom: "20px",
                textAlign: "center",
                backgroundColor: "var(--fx-surface-sidebar, #233044)",
                color: "white",
                padding: "8px",
                borderRadius: "10px",
              }}
            >
              Tell us more about you
            </Typography>
            <CheckEmployeeRequirements
              checkedState={checkedState}
              data={requirements}
              updateComponentState={updateComponentState}
            />
            {/* <CheckExperience data={commercialServices} /> */}
          </Grid>
        </Grid>

        <SignUpNextButton
          // type="submit"
          sx={{
            marginTop: "10px",
          }}
          nextViewEntityState={nextViewComponentState}
          previousViewEntityState={previousViewEntityState}
        ></SignUpNextButton>
      </Box>
    </div>
  );
};
